var render = function render(){var _vm=this,_c=_vm._self._c;return _c('quill-editor',{ref:_vm.reference,staticClass:"qs_editor mb-1",attrs:{"options":_vm.editorOption},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})
}
var staticRenderFns = []

export { render, staticRenderFns }